import PwaNetworkDiagnosticsController from "./pwa/network_diagnostics_controller"

// Chat app network diagnostics -- inherits everything from the shared base.
// No app-specific overrides needed; chat has no offline cache to report on.

export default class extends PwaNetworkDiagnosticsController {
}
